import { useState } from "react";
import {
  RightOutlined,
  CloseOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import { Dropdown, Menu } from "antd";

const MobileHeader = (props) => {
  const {
    handleMovingToLandingPage,
    handleMobileNavigation,
    handleToggle,
    toggle,
    handleImageLink,
  } = props;

  const [languageToggle, setLanguageToggle] = useState(false);
  const [closeSign, setCloseSign] = useState(false);

  const handleDropdownStates = (closeState) => {
    setCloseSign(closeState);
  };
  const handleMenuClick = () => {
    setCloseSign(!closeSign);
  };

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <li>
              <div
                className="dropdown-mobile-header-items"
                style={
                  !toggle
                    ? { fontFamily: "Mizan-AR", fontSize: "26px" }
                    : { fontFamily: "Decima Mono Pro", fontSize: "22px" }
                }
                onClick={() => {
                  handleMobileNavigation("educator");
                  handleDropdownStates(!closeSign);
                  window.scrollTo(0, 0);
                }}
              >
                <span>{toggle ? "EDUCATOR'S KIT" : "أدوات التعليـــم"}</span>
                {/* <RightOutlined /> */}
              </div>
              <Menu.Divider style={{ marginBottom: "-4px" }} />
            </li>
          ),
        },
        {
          key: "2",
          label: (
            <li>
              <div
                className="dropdown-mobile-header-items"
                style={
                  !toggle
                    ? { fontFamily: "Mizan-AR", fontSize: "26px" }
                    : { fontFamily: "Decima Mono Pro", fontSize: "22px" }
                }
                onClick={() => {
                  handleDropdownStates(!closeSign);
                  handleMobileNavigation("research");
                  window.scrollTo(0, 0);
                }}
              >
                <span>{toggle ? "RESEARCH" : "البحــــــث"}</span>
                {/* <RightOutlined /> */}
              </div>
              <Menu.Divider style={{ marginBottom: "-4px" }} />
            </li>
          ),
        },
        {
          key: "3",
          label: (
            <li>
              <div
                className="dropdown-mobile-header-items"
                style={
                  !toggle
                    ? { fontFamily: "Mizan-AR", fontSize: "26px" }
                    : { fontFamily: "Decima Mono Pro", fontSize: "22px" }
                }
                onClick={() => {
                  handleDropdownStates(!closeSign);
                  handleMobileNavigation("interview");
                  handleImageLink(false);
                  window.scrollTo(0, 0);
                }}
              >
                <span>{toggle ? "INTERVIEWS" : "مقــــابـــــلات"}</span>
                {/* <RightOutlined /> */}
              </div>
              <Menu.Divider style={{ marginBottom: "-4px" }} />
            </li>
          ),
        },
        {
          key: "4",
          label: (
            <li
              onClick={() => {
                handleDropdownStates(!closeSign);
                window.open(
                  "https://www.instagram.com/arabictypeunit/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D",
                  "_blank"
                );
              }}
            >
              <div
                className="dropdown-mobile-header-items"
                style={
                  !toggle
                    ? { width: "20%", fontFamily: "Mizan-AR", fontSize: "26px" }
                    : {
                        width: "20%",
                        fontFamily: "Decima Mono Pro",
                        fontSize: "22px",
                      }
                }
              >
                <span>{toggle ? "FOLLOW" : "إتبـــــــع"}</span>
                <RightOutlined />
                <InstagramOutlined />
              </div>
            </li>
          ),
        },
      ]}
    />
  );

  return (
    <div
      style={{
        position: "fixed",
        width: "100vw",
        background: "#fff",
      }}
    >
      <div className="mobile-header">
        <div className="mobile-header-hamburg">
          <Dropdown
            overlay={menu}
            placement="bottom"
            trigger="click"
            overlayClassName="dropdown-mobile-header"
            onVisibleChange={() => handleDropdownStates(!closeSign)}
          >
            {closeSign ? (
              <CloseOutlined
                onClick={handleMenuClick}
                className="mobile-header-hamburg-cross-icon"
              />
            ) : (
              <img
                src="/icons/hamburger_menu.svg"
                alt="Menu"
                className="mobile-header-hamburg-ham-icon"
                onClick={handleMenuClick}
              />
            )}
          </Dropdown>
        </div>

        <img
          src="/images/biscriptuallogo-vertical.png"
          className="mobile-header-logo"
          alt="Logo"
          onClick={handleMovingToLandingPage}
        ></img>
        <div className="mobile-header-toggle">
          {languageToggle ? (
            <img
              src="/icons/language_toggle_eng.svg"
              className="mobile-header-toggle-icon"
              onClick={() => {
                setLanguageToggle(false);
                handleToggle(false);
              }}
              alt="Toggle"
            ></img>
          ) : (
            <img
              src="/icons/language_toggle_arab.svg"
              className="mobile-header-toggle-icon"
              onClick={() => {
                setLanguageToggle(true);
                handleToggle(true);
              }}
              alt="Toggle"
            ></img>
          )}
        </div>
        {closeSign && <div className="mobile-header-overlay"></div>}
      </div>
    </div>
  );
};

export default MobileHeader;
